module.exports = __webpack_public_path__ + "img/Gauge-Rotor_Force_Direction-Rotating_direction_CCW_img01.12d3d131.svg";